import classNames from 'classnames';
import { JSX, useState, useLayoutEffect } from 'react';
import { DirectionalIcon, IconDirection } from '@bg-components/Icon';
import { IHowToPlaySection, sessionStore, partnerSettingsStore } from '@bg-shared';
import classes from './HowToPlaySection.module.scss';

interface IProps {
    howToPlayData: IHowToPlaySection;
}

export const HowToPlaySection = (props: IProps): JSX.Element => {
    const [opened, setOpened] = useState<boolean>(false);

    const { expandable, title, content } = props.howToPlayData;

    const onClick = (): void => {
        if (expandable) {
            setOpened(!opened);
        }
    };

    useLayoutEffect(() => {
        if (sessionStore.onlyGUI) {
            document.querySelector('video')?.remove();
        }
    }, []);

    return (
        <div
            data-qa="area-htp-content-section"
            className={classNames(classes.container, {
                [classes.expandable]: expandable,
                [classes.open]: opened,
            })}
        >
            {!!title && (
                <button className={classes.button} type="button" onClick={onClick}>
                    {expandable && (
                        <DirectionalIcon
                            className={classes.icon}
                            direction={
                                partnerSettingsStore.isRtl
                                    ? IconDirection.LEFT
                                    : IconDirection.RIGHT
                            }
                        />
                    )}
                    {title}
                </button>
            )}
            {(!expandable || opened) && (
                <div
                    data-qa="area-htp-content-section-content"
                    className={classes.content}
                    dangerouslySetInnerHTML={{ __html: content }}
                />
            )}
        </div>
    );
};
